import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { handleAxiosErrorMessage } from '../../../../../utils';

export default function useReceiveCrossdockingError() {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation(['system']);

  const crossdockingErrorHandlers = {
    ORDER_ALL_PROCCESED: ({ t, code }) => {
      return {
        message: t('ORDER_ALL_PROCCESED', { ns: 'system', code }),
        type: 'warning',
      };
    },

    ORDER_PROCESSED: ({ t, barcode }) => {
      return {
        message: t('ORDER_PROCESSED', { ns: 'system', code: barcode }),
        type: 'warning',
      };
    },

    PENDING_CARRIER_SCAN: ({ t, code }) => {
      return {
        message: t('PENDING_CARRIER_SCAN', { ns: 'system', code }),
        type: 'warning',
      };
    },

    STATUS_ORDER_NOT_SUPPORTED: ({ t, code }) => {
      return {
        message: t('STATUS_ORDER_NOT_SUPPORTED', { ns: 'system', code }),
        type: 'warning',
      };
    },

    ORDER_NOT_FOUND: ({ t, barcode }) => {
      return {
        message: t('ORDER_NOT_FOUND_CROSSDOCKING', { ns: 'system', barcode }),
        type: 'error',
      };
    },

    ORDER_EVENT_NOT_FOUND: ({ t, barcode }) => {
      return {
        message: t('ORDER_EVENT_NOT_FOUND', { ns: 'system', barcode }),
        type: 'error',
      };
    },

    PENDING_WARECLOUD_SCAN: ({ t, barcode }) => {
      return {
        message: t('PENDING_WARECLOUD_SCAN', { ns: 'system', barcode }),
        type: 'error',
      };
    },

    STATUS_ORDER_NOT_ACCEPTED: ({ t, barcode }) => {
      return {
        message: t('STATUS_ORDER_NOT_ACCEPTED', { ns: 'system', barcode }),
        type: 'error',
      };
    },
  };

  const showErrorMessage = (error, variables) => {
    const { data = {} } = error || {};
    const { data: errorData = null } = data?.data || {};

    const errorMessage = handleAxiosErrorMessage(error);
    const errorHandler = crossdockingErrorHandlers[errorMessage];

    if (errorHandler) {
      const errorResult = errorHandler({
        t,
        code: errorData?.order || errorData?.order_code,
        barcode: variables?.scanValue,
      });

      if (errorResult) {
        enqueueSnackbar(errorResult.message, {
          variant: errorResult.type,
        });
        return;
      }
    }

    enqueueSnackbar(
      t(errorMessage, { ns: 'system', code: variables?.scanValue }),
      {
        variant: 'error',
      }
    );
  };

  return { showErrorMessage };
}
